import { loadStripe, type Stripe } from "@stripe/stripe-js";

/**
 * The Stripe.js loader, cached for the session.
 *
 * Stripe.js loads from js.stripe.com and cannot be bundled. The publishable key comes from the API
 * (GET /config), not `process.env` — Bun.serve's dev bundler only inlines NODE_ENV, so env vars do
 * not reach client code. (js.stripe.com must also be CSP-allowed in production.)
 *
 * Cached module-side so the script loads once per session rather than once per modal open. Shared
 * rather than redeclared: both card-collection surfaces — the group's Add payment method modal and
 * the organization's subscription card form — need it, and two caches would load Stripe.js twice.
 */
let stripePromiseCache: Promise<Stripe | null> | null = null;

export function getStripePromise(publishableKey: string): Promise<Stripe | null> {
  if (!stripePromiseCache) stripePromiseCache = loadStripe(publishableKey);
  return stripePromiseCache;
}
